/** @jsxImportSource @emotion/react */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { AppBar, Toolbar } from '@mui/material';
import Logo from '../../../assets/logos/new-logo.png';

import { useStyles } from './TopBar.styles';

type TopBarProps = {
  className?: string;
};

const defaultProps: TopBarProps = {
  className: '',
};

export function TopBar(props: TopBarProps = defaultProps): React.ReactElement {
  const { className } = props;

  const styles = useStyles();

  return (
    <AppBar css={styles} className={className} color="primary" position="fixed">
      <Toolbar>
        <RouterLink className="link" to="/">
          <img className="logo" alt="Gaytaro" src={Logo} />
        </RouterLink>
      </Toolbar>
    </AppBar>
  );
}
